/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipi di limite di assegnazione
 */
export enum LimiteAssegnazione {

    BUDGET = 'BUDGET',

    REDISTRIBUZIONE = 'REDISTRIBUZIONE'
}

